<template>
  <div>
    <MasterHeader
      v-bind:classHeader="'registration deleteAccount'"
      v-bind:classGrid="'wp800'"/>
    <section>
      <!-- delete account step 2 -->
      <div class="deleteProfile step2 popUp wp800">
        <div class="flex">
          <img src="@/assets/images/alertIcon.svg" class="mainImageWindow"/>
          <div class="rightText">
            <h3>{{ $t("delete_profile.fail_title") }}</h3>
            <p>{{ $t("delete_profile.fail_text") }}</p>
            <router-link to="/login" class="txt">{{ $t("delete_profile.fail_link") }}</router-link>
          </div>
        </div>
      </div>
    </section>
  </div>

</template>
<script>
import MasterHeader from './partials/MasterHeader';
export default {
  components:{
    MasterHeader
  }
}
</script>